import QRDesignerComponent from "../../modules/qr-editor/QREditor";

export default function QRDesigner() {
    return <QRDesignerComponent role="user" />;
}